import { createFileRoute, Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { CrudTable, type FieldDef } from "@/features/admin/components/CrudTable";
import { Button } from "@/components/ui/button";
import { Loader2, ListChecks } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/quizzes")({
  component: AdminQuizzes,
});

function AdminQuizzes() {
  const [lessons, setLessons] = useState<{ value: string; label: string }[] | null>(null);

  useEffect(() => {
    supabase
      .from("lessons")
      .select("id,title")
      .order("sort_order")
      .then(({ data }) =>
        setLessons((data ?? []).map((r) => ({ value: r.id as string, label: r.title as string }))),
      );
  }, []);

  if (!lessons)
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );

  const fields: FieldDef[] = [
    { key: "title", label: "العنوان", required: true },
    { key: "lesson_id", label: "الدرس", type: "select", options: lessons },
    { key: "description", label: "وصف", type: "textarea" },
    { key: "pass_score", label: "نسبة النجاح %", type: "number", defaultValue: 70 },
    { key: "points_reward", label: "نقاط المكافأة", type: "number", defaultValue: 20 },
    { key: "is_published", label: "منشور", type: "switch", defaultValue: true },
  ];

  return (
    <CrudTable
      title="Quizzes"
      table="quizzes"
      fields={fields}
      orderBy={{ column: "created_at", ascending: false }}
      columns={[
        { key: "title", label: "Title" },
        {
          key: "lesson_id",
          label: "Lesson",
          render: (r) => lessons.find((l) => l.value === r.lesson_id)?.label || "—",
        },
        { key: "pass_score", label: "Pass %" },
        {
          key: "actions",
          label: "Questions",
          render: (r) => (
            <Button asChild size="sm" variant="outline" className="rounded-full">
              <Link to="/admin/questions/$quizId" params={{ quizId: r.id as string }}>
                <ListChecks className="h-3 w-3 me-1" /> Manage
              </Link>
            </Button>
          ),
        },
      ]}
    />
  );
}
